import React, { useState } from 'react';
import { Button, Col, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Modal from '../../../common/modal/Modal';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired, validateNumber } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';
import { CLONE_PRICING_PROFILE_DATE_RANGE_PATH } from '../../../../config/paths';

const ClonePricingProfileDateRangeButton = ({ handleSubmit, history }) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const onSubmit = (values) => {
    const { year, corporate } = values;

    history.push(CLONE_PRICING_PROFILE_DATE_RANGE_PATH, {
      year,
      corporate: !!corporate,
    });

    closeModal();
  };
  return (
    <>
      <Modal
        show={showModal}
        title="Clonar Rango de Fechas"
        size="md"
        onClickCancel={closeModal}
        onClickClose={closeModal}
        body={
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <FormItem label="Año">
                <Field
                  name="year"
                  component={TextInput}
                  validate={[isRequired, validateNumber]}
                  placeholder="Ej: 2026"
                />
              </FormItem>
            </FormGroup>

            <FormGroup row>
              <Col xs={12}>
                <Label>
                  <strong>Clientes Corporativos</strong>
                </Label>
              </Col>

              <Col xs={12}>
                <Field name="corporate" component="input" type="checkbox" />
                &nbsp; Generar fechas solo para clientes corporativos
              </Col>
            </FormGroup>

            <FormFooter />
          </Form>
        }
      />

      <Button color="info" className="mr-2" onClick={openModal}>
        <i className="fa fa-clone" /> Clonar
      </Button>
    </>
  );
};

ClonePricingProfileDateRangeButton.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};

export default withRouter(
  reduxForm({
    form: 'clonePricingProfileDateRangeForm',
  })(ClonePricingProfileDateRangeButton),
);
